import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Transition as _Transition, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 overflow-hidden" }
const _hoisted_3 = { class: "absolute inset-0 overflow-hidden bg-[#0000014d]" }
const _hoisted_4 = { class: "fixed inset-y-0 right-0 flex max-w-full md:pl-10 pointer-events-none" }
const _hoisted_5 = { class: "flex flex-col h-full overflow-y-scroll bg-white md:rounded-l-lg shadow-xl" }
const _hoisted_6 = { class: "relative flex flex-col" }
const _hoisted_7 = { class: "flex items-center justify-between px-6 py-4 border-b border-gray-200" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold" }, "Guardian", -1)
const _hoisted_9 = { class: "px-4 pt-1.5 pb-4" }
const _hoisted_10 = { class: "flex justify-end" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Add New", -1)
const _hoisted_12 = { class: "px-4 max-h-[calc(100vh-140px)] overflow-auto" }
const _hoisted_13 = {
  key: 0,
  class: "flex border border-gray-200 rounded-2xl items-center p-4 h-[calc(100vh-140px)] justify-center"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs italic text-center" }, "No data yet", -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "col-span-1" }
const _hoisted_17 = { class: "mb-1 text-sm font-bold" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium text-neutral-500" }, "Gender", -1)
const _hoisted_19 = { class: "col-span-1" }
const _hoisted_20 = { class: "mb-1 text-sm font-bold" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium text-neutral-500" }, "Fullname", -1)
const _hoisted_22 = { class: "col-span-1" }
const _hoisted_23 = { class: "mb-1 text-sm font-bold" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium text-neutral-500" }, " Birthdate ", -1)
const _hoisted_25 = { class: "col-span-1" }
const _hoisted_26 = { class: "mb-1 text-sm font-bold" }
const _hoisted_27 = {
  key: 0,
  class: "text-xs font-medium text-neutral-500"
}
const _hoisted_28 = {
  key: 1,
  class: "text-xs font-medium text-neutral-500"
}
const _hoisted_29 = { class: "col-span-1" }
const _hoisted_30 = { class: "mb-1 text-sm font-bold" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium text-neutral-500" }, " Relationship ", -1)
const _hoisted_32 = { class: "col-span-1" }
const _hoisted_33 = { class: "mb-1 text-sm font-bold" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-medium text-neutral-500" }, " Contact Number ", -1)
const _hoisted_35 = { class: "absolute top-4 right-4" }
const _hoisted_36 = { class: "p-4" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]

import { ref, onMounted, watch, computed, onUnmounted } from "vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import {
	Dialog,
	DialogPanel,
	TransitionChild,
	TransitionRoot,
	Menu,
	MenuButton,
	MenuItems,
	MenuItem,
} from "@headlessui/vue";
import { PlusIcon, XMarkIcon } from "@heroicons/vue/24/outline";
import { TrashIcon } from "@heroicons/vue/24/solid";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import { GuardianIndex } from "@/interfaces/Cases/Guardian";
import { useRouter, useRoute } from "vue-router";
import pickBy from "lodash/pickBy";
import { BirthdayClassification } from "@/views/enums/BirthdayClassification";
import DateFormatter from "@/helpers/DateFormatter";
import { useRecordStatusChecker } from "@/store/recordStatusChecker";
import { useDraftLogger } from "@/store/draftlogger"
import ThreeDotsIcon from "@/components/icons/threeDotsIcon.vue";
import PencilIcon from "@/components/icons/pencilIcon.vue"; 

import CaseGuardianService from "@/classes/Cases/CaseGuardian/CaseGuardianService";
import { useNetworkStore } from "@/store/network";
import CaseGuardianForm from "@/classes/Cases/CaseGuardian/Offline/Formatters/CaseGuardianForm";
import CaseGuardianOfflineProcessor from "@/classes/Cases/CaseGuardian/Offline/Processor/OfflineProcessor";

export default /*#__PURE__*/_defineComponent({
  __name: 'GuardianModal',
  props: {
	show: {
		type: Boolean,
		default: false,
	},
},
  setup(__props) {

const router = useRouter();
const route = useRoute();
/******************************* For Offline Imports ************************************ */ 
const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable); 
/*************************************************************************************** */
const props = __props; 

const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const patientId = ref<number | null>(route.params.patient);
const caseId = ref<number | null>(route.params.case);
const items = ref<GuardianIndex[]>([]);
const hasContent = ref<boolean>(false);
const selectedItemId = ref<number | null>(null);
const successMessage = ref<string>("Selected record has been successfully deleted!"); 
const recordStatusChecker = useRecordStatusChecker();
const isRecordCreated = computed(() => recordStatusChecker.isCreatedGuardian);
const draft = useDraftLogger();

const removeConfirmation = (item) => {
	showConfirmation.value = true;
	selectedItemId.value = item.id;
};

const deleteItem = async () => {
    showConfirmation.value = false;
    const response = await CaseGuardianService.delete(
		patientId.value,
		caseId.value,
		selectedItemId.value,
		pickBy({ }),
		isNetworkAvailable.value
	);
    if (response?.status === 200 || response?.data != undefined) {
        if (isNetworkAvailable.value) {
            await CaseGuardianOfflineProcessor.delete(selectedItemId.value, caseId.value, true);
        }
        showSuccess.value = true;
        recordStatusChecker.isDeleted = true;
        draft.hasDraft = true; 
    } else {
        console.log(response);
    }
};

const redirectSuccess = (): void => {
	showSuccess.value = false;
    draft.hasDraft = false;
    showConfirmation.value = false; 
};

const getData = async (): Promise<any> => {
	if (caseId.value) {
        const response = await CaseGuardianService.index(
			patientId.value,
			caseId.value,
			pickBy({  rows: 10 }),
			isNetworkAvailable.value
		); 
        console.log(response)
        if (response?.status === 200 || response?.data != undefined) {
			items.value = response.data.items;  
			hasContent.value = response.data.items.total > 0 ? true : false; 

			if(!isNetworkAvailable.value){ 
				await retrieveGuardianOffline(response);
			}
            
            if (isNetworkAvailable.value) {
                for (const item of items.value.data) {
                    await CaseGuardianOfflineProcessor.syncToOffline(caseId.value, item);
                }
            }
        }
	}
};

/**
 * Retrieve resource data 
 */
const retrieveGuardianOffline = async (response: object):any => { 
	hasContent.value = response.data.items.total > 0 ? true : false; 
	response.data.items = await Promise.all(response.data.items.data?.map(async (item: any) => {
        return  await CaseGuardianForm.viewForm(item);
    }));

	items.value = { data: response.data.items };    
};

watch(
    () => isRecordCreated.value,
    (val) => {
        if (val) {
            getData();
        }
    }
);

watch(
    () => props.show,
    (val) => {
        if (val) {
            recordStatusChecker.isDeleted = false;
            getData();
        }
    }
); 

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: __props.show
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          class: "relative z-10",
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_unref(TransitionChild), {
                    as: "template",
                    enter: "transform transition ease-in-out duration-300",
                    "enter-from": "translate-x-full",
                    "enter-to": "translate-x-0",
                    leave: "transform transition ease-in-out duration-300",
                    "leave-from": "translate-x-0",
                    "leave-to": "translate-x-full"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(DialogPanel), { class: "pointer-events-auto w-screen md:max-w-[660px]" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("div", _hoisted_7, [
                                _hoisted_8,
                                _createVNode(_unref(XMarkIcon), {
                                  class: "w-6 h-6 transition cursor-pointer stroke-2 hover:text-primary-600",
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                                })
                              ]),
                              _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                  _createElementVNode("a", {
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => {
															_unref(router).push(
																`/patient/${patientId.value}/cases/${caseId.value}/guardians/create`
															);
                                                            _ctx.$emit('close')
														})
                                  }, [
                                    _createVNode(ButtonComponent, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(PlusIcon), { class: "w-4 h-4 text-primary-600 stroke-[3px] -ml-2 mr-1 icon" }),
                                        _hoisted_11
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_12, [
                                (!hasContent.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                                  : _createCommentVNode("", true),
                                (hasContent.value)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(items.value.data, (item) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: item,
                                        class: "relative grid grid-cols-2 gap-2 p-4 mb-4 border border-gray-200 rounded-2xl pr-11"
                                      }, [
                                        _createElementVNode("div", _hoisted_16, [
                                          _createElementVNode("p", _hoisted_17, _toDisplayString(item?.gender_meta?.description) + "   ", 1),
                                          _hoisted_18
                                        ]),
                                        _createElementVNode("div", _hoisted_19, [
                                          _createElementVNode("p", _hoisted_20, _toDisplayString(item?.name) + "  ", 1),
                                          _hoisted_21
                                        ]),
                                        _createElementVNode("div", _hoisted_22, [
                                          _createElementVNode("p", _hoisted_23, _toDisplayString(item?.birthdate ? _unref(DateFormatter).customDateFormat(item?.birthdate, 'MM/dd/yyy') : 'Unknown') + "  ", 1),
                                          _hoisted_24
                                        ]),
                                        _createElementVNode("div", _hoisted_25, [
                                          _createElementVNode("p", _hoisted_26, _toDisplayString(item?.computed_age) + "  ", 1),
                                          (_unref(BirthdayClassification).APPROXIMATE_AGE == item.birthday_classification)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_27, " Approximate Age "))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_28, " Age "))
                                        ]),
                                        _createElementVNode("div", _hoisted_29, [
                                          _createElementVNode("p", _hoisted_30, _toDisplayString(item?.relationship?.name) + "   ", 1),
                                          _hoisted_31
                                        ]),
                                        _createElementVNode("div", _hoisted_32, [
                                          _createElementVNode("p", _hoisted_33, _toDisplayString(item?.contacts) + "  ", 1),
                                          _hoisted_34
                                        ]),
                                        _createElementVNode("div", _hoisted_35, [
                                          _createVNode(_unref(Menu), null, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(MenuButton), null, {
                                                default: _withCtx(() => [
                                                  _createVNode(ThreeDotsIcon, { class: "object-contain w-5 h-5 cursor-pointer" })
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_Transition, {
                                                "enter-active-class": "transition duration-100 ease-out",
                                                "enter-from-class": "transform scale-95 opacity-0",
                                                "enter-to-class": "transform scale-100 opacity-100",
                                                "leave-active-class": "transition duration-75 ease-in",
                                                "leave-from-class": "transform scale-100 opacity-100",
                                                "leave-to-class": "transform scale-95 opacity-0"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_unref(MenuItems), { class: "absolute right-0 z-10 mt-2 min-w-[180px] origin-top-right rounded bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("div", _hoisted_36, [
                                                        _createVNode(_unref(MenuItem), null, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("a", {
                                                              onClick: ($event: any) => {
																						_unref(router).push(`/patient/${patientId.value}/cases/${caseId.value}/guardian/${item.id}/edit`); _ctx.$emit('close')
																					},
                                                              class: "flex items-center mb-2 text-sm cursor-pointer"
                                                            }, [
                                                              _createVNode(PencilIcon, { class: "w-6 h-6 object-contain mr-1.5 invert" }),
                                                              _createTextVNode(" Edit ")
                                                            ], 8, _hoisted_37)
                                                          ]),
                                                          _: 2
                                                        }, 1024),
                                                        _createVNode(_unref(MenuItem), null, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("p", {
                                                              class: "flex items-center text-sm cursor-pointer",
                                                              onClick: ($event: any) => (removeConfirmation(item))
                                                            }, [
                                                              _createVNode(_unref(TrashIcon), { class: "w-6 h-6 mr-1.5" }),
                                                              _createTextVNode(" Remove ")
                                                            ], 8, _hoisted_38)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ])
                                      ]))
                                    }), 128))
                                  : _createCommentVNode("", true),
                                _renderSlot(_ctx.$slots, "default")
                              ])
                            ])
                          ])
                        ]),
                        _: 3
                      })
                    ]),
                    _: 3
                  })
                ])
              ])
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"]),
    _createVNode(ConfirmationModal, {
      typeTwo: true,
      show: showConfirmation.value,
      onCancel: _cache[3] || (_cache[3] = ($event: any) => (showConfirmation.value = false)),
      onConfirm: _cache[4] || (_cache[4] = ($event: any) => (deleteItem())),
      "cancel-text": "Cancel",
      "action-text": "Confirm",
      title: "Delete Record?",
      content: "Are you sure you wish to delete this record?"
    }, null, 8, ["show"]),
    _createVNode(SuccessModal, {
      show: showSuccess.value,
      onConfirm: _cache[5] || (_cache[5] = ($event: any) => (redirectSuccess())),
      "action-text": "Close",
      title: "Record Deleted!",
      content: successMessage.value
    }, null, 8, ["show", "content"])
  ]))
}
}

})